import {filter, includes, join, lowerCase, map, size} from 'lodash';
import {useState} from 'react';

import ListItem, {parseDescription} from 'components/List/Item';
import {getBaseUrl} from 'conf/types';

export default function PublicationsList({literature}) {
  const [textFilter, setTextFilter] = useState('');

  const handleChange = (e) => {
    if (e.target.value) {
      setTextFilter(e.target.value);
    } else {
      setTextFilter('');
    }
  };
  const filterLit = (lit) => includes(mapToDisplayText(lit), lowerCase(textFilter));
  return (
    <div>
      <div>
        <div>Search</div>
        <input id="pub-filter-field" onChange={handleChange} className="form-control" />
      </div>
      <p className="text-muted">{size(filter(literature, filterLit))} Publications</p>
      {map(filter(literature, filterLit), renderItem)}
    </div>
  );
}

function renderItem(item) {
  const description = parseDescription({item, showTags: true, showXrefLinks: true});
  const extras = item?.links?.length > 0
    ? <ul>{map(item.links, (l) => <li key={l.url}><a href={l.url}>{l.name}</a></li>)}</ul>
    : null;

  return (
    <ListItem
      key={item.id}
      objCls={item.objCls}
      name={item.title}
      url={item.url ?? getBaseUrl(item.id, item.objCls)}
      description={description}
      thumbnailLink={item?.thumbnailLink}
      className="listItemContainer"
      extras={extras}
    />
  );
}

function mapToDisplayText(item) {
  const {title, authors, crossReferences, year, journal, terms} = item;
  return ([
    title,
    join(authors, ' '),
    join(map(crossReferences, 'resourceId'), ' '),
    `${year}`,
    join(map(terms, 'term'), ' '),
    journal,
  ]).join(' ').toLowerCase();
}
